export default __webpack_public_path__ + "static/media/fashion.7cb03427.jpg";